document.addEventListener("click", function (event) {
  const link = event.target.closest('[data-checkin-url]:not([data-checkin-url=""])');
  if (!link) return;

  // Prevent the default action of the link
  event.preventDefault();
  event.stopImmediatePropagation();

  // Get the data-checkin-url attribute from the clicked link
  const iframeUrl = link.getAttribute("data-checkin-url") || link.getAttribute("data-bs-url");
  if (!iframeUrl) return;

  // Get the checkin container and iframe
  const container = document.querySelector('div#checkInContainer');
  const iframe = document.querySelector('iframe#checkInFrame');

  if (!container || !iframe) return;

  // Update the iframe src and show the container
  iframe.setAttribute("src", iframeUrl);
  container.classList.add('visible');
  document.body.classList.add('checkin-open');
});

// Wait for the DOM to be completely loaded
document.addEventListener("DOMContentLoaded", () => {
  const returnButton = document.querySelector('div#checkInReturnButton');
  const container = document.querySelector('div#checkInContainer');
  const iframe = document.querySelector('iframe#checkInFrame');

  if (!returnButton || !container || !iframe) return;

  // Handle return button click
  returnButton.addEventListener("click", function (event) {
    event.preventDefault();
    closeCheckinModal();
  });

  // Listen for message from the iframe
  window.addEventListener('message', function (event) {
    // Validate the origin of the message
    const allowedOrigins = ['https://checkin.tommyguns.com'];

    if (allowedOrigins.includes(event.origin) && event.data === 'wci-close-iframe') {
      closeCheckinModal();
    }
  });

  // Function to close the checkin modal
  function closeCheckinModal() {
    iframe.setAttribute("src", 'about:blank');
    container.classList.remove('visible');
    document.body.classList.remove('checkin-open');
  }
});
